import { render } from "./Sales.vue?vue&type=template&id=613949cd&scoped=true&ts=true"
import script from "./Sales.vue?vue&type=script&lang=ts"
export * from "./Sales.vue?vue&type=script&lang=ts"

import "./Sales.vue?vue&type=style&index=0&id=613949cd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613949cd"]])

export default __exports__